// ------------------------------------
// Constants
// ------------------------------------
export const PERSON_FETCH = 'PERSON_FETCH';
export const PERSON_FETCH_SUCCESS = 'PERSON_FETCH_SUCCESS';
export const PERSON_FETCH_ERROR = 'PERSON_FETCH_ERROR';

export const PERSON_DELETE = 'PERSON_DELETE';
export const PERSON_DELETE_SUCCESS = 'PERSON_DELETE_SUCCESS';
export const PERSON_DELETE_ERROR = 'PERSON_DELETE_ERROR';

export const SEND_INVITE = 'SEND_INVITE';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_ERROR = 'SEND_INVITE_ERROR';

export const SEND_INVITE_ALL = 'SEND_INVITE_ALL';
export const SEND_INVITE_ALL_SUCCESS = 'SEND_INVITE_ALL_SUCCESS';
export const SEND_INVITE_ALL_ERROR = 'SEND_INVITE_ALL_ERROR';

export const SEND_RESETPASSWORD = 'SEND_RESETPASSWORD';
export const SEND_RESETPASSWORD_SUCCESS = 'SEND_RESETPASSWORD_SUCCESS';
export const SEND_RESETPASSWORD_ERROR = 'SEND_RESETPASSWORD_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

export function fetchPerson(personId) {
  return {
    type: PERSON_FETCH,
    identifier: 'people',
    payload: {
      personId: personId,
    },
  };
}

export function deletePerson(personId) {
  return {
    type: PERSON_DELETE,
    identifier: 'people',
    payload: {
      personId: personId,
    },
  };
}

export function sendInvite(emails) {
  return {
    type: SEND_INVITE,
    identifier: 'people',
    payload: {
      data: {
        emails,
      },
    },
  };
}

export function sendInviteAll() {
  return {
    type: SEND_INVITE_ALL,
    identifier: 'peopleall',
    payload: {},
  };
}

export function sendResetPassword(person) {
  return {
    type: SEND_RESETPASSWORD,
    identifier: 'people',
    payload: {
      id: person.id,
    },
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {};

export default function PeopleReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
